  window.Dbmng = Dbmng;
})(); 
